<template>
  <div class="login">
    <div class="inset">
      <img class="logo" src="../assets/logo_nav.png" />
      <div class="info" v-if="type == 'login'">
        <div class="login-type c-center">密码登录</div>
        <el-form :model="form" ref="form" size="medium">
          <el-form-item
            prop="phone"
            :rules="{
              required: true,
              trigger: ['change', 'blur'],
              message: '请输入手机号'
            }"
          >
            <el-input
              v-model="form.phone"
              prefix-icon="el-icon-mobile-phone"
              placeholder="手机号"
              size="medium"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="password"
            :rules="{
              required: true,
              trigger: ['change', 'blur'],
              message: '请输入密码'
            }"
          >
            <el-input
              v-model="form.password"
              prefix-icon="el-icon-lock"
              placeholder="密码"
              show-password
              size="medium"
              clearable
              @keyup.enter.native="login"
            ></el-input>
          </el-form-item>

          <el-form-item
            prop="imageCode"
            :rules="{
              required: true,
              trigger: ['change', 'blur'],
              message: '请输入验证码'
            }"
          >
            <el-input
              v-model="form.imageCode"
              placeholder="验证码"
              size="medium"
              clearable
              class="c-input-captcha"
            >
              <template slot="append">
                <img
                  width="140px"
                  height="38px"
                  v-if="captcha"
                  :src="captcha"
                  class="c-flex c-pointer"
                  style="border-radius: 0 4px 4px 0;"
                  @click="getImageCaptcha()"
                />
              </template>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click="login()"
              size="medium"
              class="c-w-1"
              style="height:40px;background:#106cff"
            >
              登 录
            </el-button>
          </el-form-item>
          <el-form-item>
            <div class="c-flex c-flex-between">
              <el-link type="info" :underline="false" @click="clearCache()">
                清除缓存
              </el-link>
              <el-link type="info" :underline="false" @click="typeChange('changePassword')">
                忘记密码
              </el-link>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div class="info" v-else-if="type == 'changePassword'">
        <div class="login-type c-center">重设密码</div>
        <el-form :model="changePasswordForm" ref="form" size="medium">
          <el-form-item prop="phone" :rules="phoneRules">
            <el-input
              v-model="changePasswordForm.phone"
              placeholder="手机号"
              size="medium"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item prop="newPasswd" :rules="newPasswordRules">
            <el-input
              v-model="changePasswordForm.newPasswd"
              placeholder="新密码"
              size="medium"
              clearable
              autocomplete="new-password"
            ></el-input>
          </el-form-item>

          <el-form-item
            prop="sendVerifyCode"
            :rules="{
              required: true,
              trigger: ['change', 'blur'],
              message: '请输入手机验证码'
            }"
          >
            <el-input
              v-model="changePasswordForm.sendVerifyCode"
              placeholder="手机验证码"
              class="getsms-input"
            >
              <template slot="append">
                <el-button v-if="!sent" @click="getSms" type="primary" class="getsms-button">
                  获取验证码
                </el-button>
                <el-button v-else type="primary" class="getsms-button">
                  {{ count }}秒后重新获取
                </el-button>
              </template>
            </el-input>
          </el-form-item>

          <el-form-item>
            <el-button
              type="primary"
              @click="changePassword()"
              size="medium"
              class="c-w-1"
              style="height:40px;background:#106cff"
            >
              确 认
            </el-button>
          </el-form-item>
          <el-form-item>
            <div class="c-center c-pointer" style="color:#106cff" @click="typeChange('login')">
              返回密码登录
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div class="desc">
        <div class="slogan">
          <!-- <span class="line"></span> -->
          <span>
            修链科技
            <span class="dot"></span>
            数字化赋能房屋维修
          </span>
          <!-- <span class="line"></span> -->
        </div>
        <el-link
          type="info"
          href="https://beian.miit.gov.cn"
          target="_blank"
          :underline="false"
          class="icp"
        >
          网站备案号：京ICP备17038172号-3
        </el-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  activated() {
    window.$this = this;
  },
  name: 'login',
  data() {
    window.$this = this;
    // 手机号校验函数
    const validatePhone = (rule, value, callback) => {
      const phonePattern = /^1[3-9]{1}\d{9}$/;
      if (!value) {
        callback(new Error('请输入手机号'));
      } else if (!phonePattern.test(value)) {
        callback(new Error('请输入正确格式的手机号'));
      } else {
        callback();
      }
    };
    // 密码校验函数
    const validatePassword = (rule, value, callback) => {
      const passwordPattern = /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[\W_]).{8,16}$/;
      if (!value) {
        callback(new Error('请输入新密码'));
      } else if (!passwordPattern.test(value)) {
        callback(new Error('8-16位，需同时包含大小写字母、数字、特殊字符'));
      } else {
        callback();
      }
    };
    return {
      type: 'login',
      form: {
        phone: '',
        password: '',
        imageCode: ''
      },
      captcha: '', // 图片验证码
      changePasswordForm: {
        phone: '',
        newPasswd: '',
        sendVerifyCode: ''
      },
      // 手机号校验规则
      phoneRules: [
        { required: true, message: '请输入手机号', trigger: ['blur', 'change'] },
        { validator: validatePhone, trigger: ['blur', 'change'] }
      ],
      // 新密码校验规则
      newPasswordRules: [
        { required: true, message: '请输入新密码', trigger: ['blur', 'change'] },
        { validator: validatePassword, trigger: ['blur', 'change'] }
      ],
      // 获取手机验证码
      sent: false,
      count: 60
    };
  },
  mounted() {
    let href = window.location.href;
    // http自动转https
    if (
      href.startsWith('http:') &&
      href.indexOf('localhost') == -1 &&
      href.indexOf('127.0.01') == -1 &&
      href.indexOf('8070') == -1
    ) {
      href = 'https:' + href.substring(5);
      window.location.href = href;
    }

    //cookie有值无需登录，注销时cookie会赋值为空
    let cookie = this.$util.cookie.get(this.$util.cookieRelative.token);
    if (cookie) {
      this.getAccount();
    }

    this.getImageCaptcha();
  },
  methods: {
    //同一浏览器新建标签页，如果有token不需要重新登录
    getAccount() {
      this.osg.ajax(
        '/account/getOneself.do',
        {},
        res => {
          sessionStorage['entity'] = JSON.stringify(res);
          this.osg.customize.bizId = res.entityID;
          this.osg.customize.entity = res;
          //获取菜单
          this.$router.push('/NavMenu');
        },
        {
          noload: true
        }
      );
    },
    //登录
    login() {
      if (this.osg.validate('form')) {
        //将登陆信息放入请求头
        let userdetail =
          this.$util.cookieRelative.basic +
          ' ' +
          this.$util.Base64.encode(this.form.phone + ':' + this.form.password);
        let header = {};
        header[this.$util.cookieRelative.authorization] = userdetail;
        this.osg.ajax(
          'login',
          { imageCode: this.form.imageCode },
          res => {
            //登陆信息有误时提示
            if (!res.data.success) {
              if (res.data.message) this.osg.alert(res.data.message);
              return;
            }

            // 接口没有访问权限时会赋值
            this.osg.httpStatusCode = '';

            // //将客户是否有外呼权限放入缓存
            // window.sessionStorage['userData'] = JSON.stringify(res.data.data);

            //将用户信息存到sessionStorage
            window.sessionStorage['entity'] = JSON.stringify(res.data.entity);
            this.osg.customize.bizId = res.data.entity.entityID;
            this.osg.customize.entity = res.data.entity;

            //获取响应x-auth-token 并将token存到cookie

            let token = res.headers['x-auth-token'];
            this.$util.cookie.set(
              this.$util.cookieRelative.token,
              token,
              this.$util.cookieRelative.tokenExpires
            );

            //重新登录清除数据缓存
            window.sessionStorage.removeItem('preFilter');
            window.sessionStorage.removeItem('filter');
            window.sessionStorage.removeItem('dashboardsChoose');
            window.localStorage.removeItem('roleChangeData');
            //获取菜单
            this.$router.push('/NavMenu');
          },
          { header }
        );
      }
    },
    // 获取验证码
    getImageCaptcha() {
      this.osg.getImageCaptcha(captcha => {
        this.captcha = captcha;
      });
    },
    changePassword() {
      if (this.osg.validate('form')) {
        this.osg.ajax(
          '/i/phone/changePassword.do',
          {
            phone: this.changePasswordForm.phone,
            newPassword: this.changePasswordForm.newPasswd,
            code: this.changePasswordForm.sendVerifyCode,
            tenantId: '1340835581184723420'
          },
          () => {
            this.changePasswordForm = {
              phone: '',
              newPasswd: '',
              sendVerifyCode: ''
            };
            this.typeChange('login');
            this.osg.alert('密码修改成功，请重新登录！');
          }
        );
      }
    },
    /**
     * 获取验证码
     */
    getSms() {
      console.log('this.changePasswordForm.phone', this.changePasswordForm.phone);
      if (!this.changePasswordForm.phone) {
        this.osg.toast('请输入手机号', 'warning');
        return;
      }
      if (!/^1[3-9]{1}\d{9}$/.test(this.changePasswordForm.phone)) {
        this.osg.toast('请输入正确格式的手机号', 'warning');
        return;
      }
      let timestamp = new Date().getTime();
      let phone = this.changePasswordForm.phone;
      this.osg.ajax(
        '/i/phone/sendVerifyCode.do',
        {
          tenantId: '1340835581184723420',
          timestamp,
          phone,
          m: window.md5('xlink*api*md5' + timestamp + phone)
        },
        () => {
          // 验证码已发送
          this.sent = true;
          // 倒计时60s
          this.count = 60;
          var timer = setInterval(() => {
            --this.count;
            if (this.count == 0) {
              clearInterval(timer);
              this.sent = false;
            }
          }, 1000);
        }
      );
    },
    // 清除cookie、sesssion、浏览器的缓存
    clearCache() {
      this.$util.cookie.deleteAllCookies();
      localStorage.clear();
      sessionStorage.clear();
      // 强制刷新页面清除浏览器缓存
      // window.location.reload(true); // 浏览器忽略缓存，从服务器端获取最新版本的页面，并不是所有浏览器都支持忽略缓存
      this.osg.toast('已清除缓存');
      window.location.href = window.location.origin + '?refresh=' + Date.now();
    },
    typeChange(type) {
      this.type = type;
      if (type == 'changePassword' && /^1[3-9]{1}\d{9}$/.test(this.form.phone)) {
        this.changePasswordForm.phone = this.form.phone;
      } else {
        this.changePasswordForm.phone = '';
      }
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate();
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.login {
  background-image: url('../assets/login_bg.jpg');
  background-size: cover;
  background-position: center;
  width: 100vw;
  height: 100vh;
  .inset {
    background-image: url('../assets/login_inset.png');
    background-size: cover;
    background-position: center;
    width: 100vw;
    height: 100vh;
    .logo {
      position: absolute;
      top: 20px;
      left: -50px;
      z-index: 1;
      width: 300px;
    }
    .info {
      width: 400px;
      box-sizing: border-box;
      padding: 0 40px;
      border-radius: 8px;
      background: #fff;
      position: absolute;
      right: 10%;
      top: 50%;
      transform: translate(0, -50%);
      -webkit-box-shadow: 0px 8px 24px 0px rgba(42, 94, 173, 0.06);
      box-shadow: 0 8px 24px rgba(42, 94, 173, 0.06);
      .login-type {
        font-size: 20px;
        font-weight: 700;
        margin: 40px 0;
      }
      .el-form-item {
        margin-bottom: 30px;
      }
      ::v-deep .el-form-item__content {
        line-height: 40px;
      }
      ::v-deep .el-input__inner {
        height: 40px !important;
        line-height: 40px !important;
      }
      ::v-deep .el-input-group__append {
        padding: 0;
      }
      .getsms-input {
        ::v-deep .el-input-group__append {
          border: 0;
        }
      }
      .getsms-button {
        width: 140px;
        float: inline-end;
        height: 40px;
        margin: 0;
        background-color: #106cff;
        color: #fff;
        border-radius: 0 4px 4px 0;
      }
    }
    .desc {
      line-height: 20px;
      text-align: center;
      position: absolute;
      bottom: 1.2%;
      width: 100%;
      font-size: 14px;
      letter-spacing: -0.2px;
      color: #909399;
      font-weight: 400;
      font-family: PingFang SC;
      .slogan {
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        .line {
          width: 40px;
          border-bottom: 1px solid rgb(153, 153, 153);
          margin: 0 16px;
        }
        .dot {
          display: inline-block;
          width: 3px;
          height: 3px;
          margin: 3px 5px;
          border-radius: 50%;
          background-color: #888;
        }
      }
      .icp {
        margin: 8px 0 0;
        font-weight: normal;
      }
    }
  }

  // 媒体查询：在平板和手机端隐藏背景并居中.info元素
  @media (max-width: 768px) {
    // 768px可以根据需要调整
    .inset {
      background-image: none; // 隐藏背景
    }

    .info {
      right: auto; // 确保取消右侧定位
      left: 50%; // 设置左侧为50%
      transform: translate(-50%, -50%) !important; // 使其水平和垂直居中
    }
  }

  // 媒体查询：当屏幕宽度小于400px时
  @media (max-width: 400px) {
    .info {
      width: 350px !important; // 设置宽度为350px
    }
  }
}
</style>
